/**
* Testimonial Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonial Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'testimonial-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.content-slider-container' ).slick( {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        dots: false,
        fade: true,
        autoplaySpeed: 5000,
        draggable: false,
        asNavFor: '.image-slider-container',
      } );
      $( '.image-slider-container' ).slick( {
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.content-slider-container',
        focusOnSelect: true,
        autoplay: true,
        autoplaySpeed: 5000,
        cssEase: 'cubic-bezier( 0.390, 0.575, 0.565, 1.000 )',
        dots: true,
        arrows: true,
        appendDots: $( '.dots-container' ),
        appendArrows: $( '.arrows-container' ),
        prevArrow: '<div class="flex items-center justify-center mb-0 md:mb-5 slick-prev h-10 w-10 rounded-full bg-brand-green"><svg class="ml-1 icon icon-double-arrow text-white text-base"><use xlink:href="#icon-double-arrow"></use></svg></div>',
        nextArrow: '<div class="flex items-center justify-center mr-10 md:mr-0 slick-prev h-10 w-10 rounded-full bg-brand-green"><svg class="icon icon-double-arrow text-white text-base transform rotate-180"><use xlink:href="#icon-double-arrow"></use></svg></div>',
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonial-slider', COMPONENT );
} )( app );
